import React from "react";
import "./BottomNav.css";
const BottomNav = () => {
  return (
    <div className='bottomNav'>
      <p>BottomNav</p>
    </div>
  );
};

export default BottomNav;
